import { ModelStateList, modelState } from '@/utils/modelState';
import { NumericConditionComponent } from './NumericConditionComponent';
import { QueryBuilder } from './QueryBuilder';
import { ScheduleConditionComponent } from './ScheduleConditionComponent';
import { ScheduleEvent } from './ScheduleWrapperComponent';
import { v4 as uuidv4 } from 'uuid';

export namespace OccupancyCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "Occupancy",
        name: "Occupancy",
        isCondition: isOccupancyCondition,
        create: createOccupancyCondition,
        hydrate: hydrateOccupancyCondition,
        serialize: serializeOccupancyCondition,
        deserialize: deserializeOccupancyCondition,
        renderComponent: renderComponent
    };

    export const OccupancyCondition = Symbol("OccupancyCondition");
    export interface OccupancyCondition extends QueryBuilder.ConditionNodeChild {
        [OccupancyCondition]: boolean;
        operator: modelState<string>;
        value: modelState<number>;
    }

    export function isOccupancyCondition(condition?: QueryBuilder.ConditionNodeChild): condition is OccupancyCondition {
        if (!condition) {
            return false;
        }

        return (condition as OccupancyCondition)[OccupancyCondition] === true;
    }

    export function createOccupancyCondition(skipHydration: boolean = false): OccupancyCondition {

        const condition: OccupancyCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [OccupancyCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            operator: modelState("gt"),
            value: modelState(0),
            dispose: () => { }
        };

        if (!skipHydration) {
            hydrateOccupancyCondition(condition);
        }

        return condition;
    }

    export function hydrateOccupancyCondition(condition: OccupancyCondition, recursive: boolean = false) {
        const unsubscribeList = [
            condition.operator.subscribe(() => {
                condition.version.setValue(condition.version.value + 1);
            }),
            condition.value.subscribe(() => {
                condition.version.setValue(condition.version.value + 1);
            })
        ];

        const oldDispose = condition.dispose;

        condition.dispose = () => {
            unsubscribeList.forEach(u => u());

            oldDispose();
        };
    }

    function serializeOccupancyCondition(condition: OccupancyCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const conditionDto: OccupancyConditionDto = {
            NodeId: condition.id,
            Operator: condition.operator.value,
            Value: condition.value.value
        };

        return {
            Type: "Occupancy",
            Value: conditionDto
        };
    }

    interface OccupancyConditionDto extends QueryBuilder.NodeDto {
        Operator: string;
        Value: number;
    }

    function deserializeOccupancyCondition(conditionDto: OccupancyConditionDto): OccupancyCondition {
        const condition = createOccupancyCondition(true);

        condition.operator.setValue(conditionDto.Operator);
        condition.operator.commit();

        condition.value.setValue(conditionDto.Value);
        condition.value.commit();

        return condition;
    }

    function renderComponent(condition: OccupancyCondition) {
        return (
            <div>
                <NumericConditionComponent operator={condition.operator} value={condition.value} />
            </div>
        );
    }
}